import React, { type ComponentProps, type FC } from 'react';
import { ElementFactory, Question, Serializer } from 'survey-core';
import { ReactQuestionFactory } from 'survey-react-ui';

import PreviousFormula from '../../components/previousFormula';

const PREVIOUS_FORMULA_TYPE = 'previous-formula';

export class PreviousFormulaModel extends Question {
  getType() {
    return PREVIOUS_FORMULA_TYPE;
  }
}

export const bootPreviousFormulaQuestion = () => {
  // Add question type metadata for further serialization into JSON
  Serializer.addClass(
    PREVIOUS_FORMULA_TYPE,
    [],
    () => {
      return new PreviousFormulaModel('');
    },
    'question',
  );

  ElementFactory.Instance.registerElement(PREVIOUS_FORMULA_TYPE, (name) => {
    return new PreviousFormulaModel(name);
  });

  ReactQuestionFactory.Instance.registerQuestion(
    PREVIOUS_FORMULA_TYPE,
    (props) => {
      return React.createElement<ComponentProps<any>>(
        PreviousFormula as FC,
        props,
      );
    },
  );
};
